
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tooltipRef: null,
      arrowRef: null,

      // animation
      prevIndex: 0,
      prevTarget: null,
      nextTarget: null,
      timeline: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
      this.initAnimation()
    })
  },
  methods: {
    init() {
      this.tooltipRef = this.$refs.tooltipRef?.[0]
      this.arrowRef = this.$refs.arrowRef?.[0]
    },
    initAnimation() {
      this.$gsap.context(() => {
        this.$gsap.set('.content', {
          autoAlpha: 0,
          pointerEvent: 'none',
        })
        this.$gsap.set('.seal-rings', {
          transformOrigin: 'center center',
        })
        this.$gsap.set('.caption', {
          opacity: 0,
        })

        this.$gsap.to('.seal-rings', {
          rotate: 360,
          duration: 160,
          replay: -1,
        })

        this.$gsap.to('.caption', {
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: '.caption',
            start: 'bottom center+=20%',
            // end: 'center center',
            // markers: true,
          },
        })

        // reveal first item content
        this.$gsap.utils.toArray('.content').forEach((el, i) => {
          if (i === 0) {
            this.$gsap.to(el, {
              autoAlpha: 1,
              duration: 0.2,
            })

            this.prevTarget = el
          }
        })
      }, this.$refs.container)
    },

    enter(event, index) {
      const parent = event.target.parentElement
      const target = parent?.querySelector(`[data-index="${index}"]`)
      const targetContent = target.querySelector(`.content`)

      this.nextTarget = targetContent

      if (!target || this.prevIndex === index) return

      // flip tooltip shape
      const state = this.$Flip.getState(this.tooltipRef)
      target.appendChild(this.tooltipRef)

      this.$Flip.from(state, {
        absolute: true,
        duration: 0.2,
        ease: 'easeInOut',
      })

      // flip arrow
      const arrowState = this.$Flip.getState(this.arrowRef)
      parent.appendChild(this.arrowRef)

      this.$Flip.from(arrowState, {
        absolute: true,
        duration: 0.2,
        ease: 'easeInOut',
      })

      // kill previous tweens if any
      this.$gsap.killTweensOf([this.prevTarget])

      // reveal tooltip text
      this.timeline = this.$gsap
        .timeline({ overwrite: true })
        .to(this.prevTarget, {
          autoAlpha: 0,
          duration: 0.1,
        })
        .to(
          this.nextTarget,
          {
            autoAlpha: 1,
            duration: 0.2,
          },
          '>+=.1'
        )

      this.prevTarget = this.nextTarget
      this.prevIndex = index
    },
  },
}
